import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchNonAdfs } from "./companyAPI";

export interface NonAdfsState {
  nonadfs: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: NonAdfsState = {
  nonadfs: [],
  status: "idle",
};

export const GetNonAdfs = createAsyncThunk(
  "company/fetchNonAdfs",
  async (data:any) => {
    const response = await fetchNonAdfs(data);
    return response;
  }
);

export const nonAdfsSlice = createSlice({
  name: "nonAdfs",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetNonAdfs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetNonAdfs.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetNonAdfs.fulfilled, (state, action) => {
        state.status = "success";
        state.nonadfs = action.payload;
      });
  },
});

export const {} = nonAdfsSlice.actions;

export const selectNonAdfs = (state: RootState) => {
  return state.nonAdfs.nonadfs;
};

export default nonAdfsSlice.reducer;
